import React from "react";
import { useParams } from "react-router-dom";
import UbereatWidget from "./UbereatWidget";

const IframeUbereats = () => {
  const { widgetId } = useParams();
  return <UbereatWidget widgetId={widgetId} />;
};

export default IframeUbereats;
